import React, { useEffect, useState } from 'react';
import { Grid, Box, Button, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchObjets } from '../store/objet';
import ObjetCard from './ObjetCard';

const ITEMS_PER_PAGE = 10;

const TousLesObjets = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const objets = useSelector((state) => state.objet.items);

  const [currentPage, setCurrentPage] = useState(1);

  const searchParams = new URLSearchParams(location.search);
  const categoryId = searchParams.get('category');

  useEffect(() => {
    if (categoryId) {
      dispatch(fetchObjets(categoryId));
    } else {
      dispatch(fetchObjets());
    }
    setCurrentPage(1); // Reset page when category changes
  }, [categoryId, dispatch]);

  const filteredObjets = objets.filter(objet => objet?.pays?.nom && objet?.prix);
  const totalPages = Math.ceil(filteredObjets.length / ITEMS_PER_PAGE) || 1;
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentItems = filteredObjets.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  return (
    <Box sx={{ backgroundColor: '#232323', py: 5, minHeight: '100vh' }}>
      <Grid container spacing={2} justifyContent="center" sx={{ mt: 3, mb:6 }}>
        {currentItems.length > 0 ? (
          currentItems.map((objet) => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.25} key={objet.id || objet._id}>
              <ObjetCard objet={objet} />
            </Grid>
          ))
        ) : (
          <Typography variant="body1" sx={{ color: '#A68E5D', mt: 4 }}>
            Aucun objet trouvé pour cette catégorie.
          </Typography>
        )}
      </Grid>

      {totalPages > 1 && (
  <Box
    sx={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      backgroundColor: '#232323',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      py: 2,
      zIndex: 10,
      borderTop: '1px solidrgb(0, 0, 0)',
    }}
  >
    <Button
      onClick={handlePreviousPage}
      disabled={currentPage === 1}
      sx={{
        color: '#fff',
        fontWeight: 'bold',
        mx: 1,
        '&:hover': { backgroundColor: 'rgba(255, 0, 0, 0.1)' },
      }}
    >
      Précédent
    </Button>

    <Typography
      variant="body1"
      sx={{ mx: 2, color: '#A68E5D', fontWeight: 'bold' }}
    >
      Page {currentPage} / {totalPages}
    </Typography>

    <Button
      onClick={handleNextPage}
      disabled={currentPage === totalPages}
      sx={{
        color: '#fff',
        fontWeight: 'bold',
        mx: 1,
        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
      }}
    >
      Suivant
    </Button>
  </Box>
)}

    </Box>
  );
};

export default TousLesObjets;
